import { debounceTime, mergeMap, withLatestFrom, filter } from 'rxjs/operators';
import { NetworkStatus } from '@cbridge-utils/network';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { IPriceFilteringRule, priceFilteringRuleStoreSelector, PriceFilteringRuleAction } from '@cbridge-packages/price-filtering-rules';
import {
  RulesManagementAction, rulesActiveSelector, hasRuleValidationErrorsSelector, RULE_VALIDATION_DEBOUNCE,
} from '@cbridge-modules/rules-management-page';

type IState =
  & IGetSelectorStateType<typeof rulesActiveSelector>
  & IGetSelectorStateType<typeof priceFilteringRuleStoreSelector>;

export const validatePriceFilteringRulesEpic: IEpic<IState> = (action$, state$) => action$.pipe(
  isTypeOf(
    RulesManagementAction.removeRule,
    RulesManagementAction.restoreRule,
    RulesManagementAction.updateRule,
    RulesManagementAction.reorderRule,
  ),
  debounceTime(RULE_VALIDATION_DEBOUNCE),
  withLatestFrom(state$),
  filter(([, state]) => !hasRuleValidationErrorsSelector(state)),
  mergeMap(([, state]) => {
    const { networkStatus } = priceFilteringRuleStoreSelector(state);
    if (networkStatus !== NetworkStatus.Done) {
      return [];
    }

    const rules = rulesActiveSelector(state);
    return [PriceFilteringRuleAction.validate.started(rules as IPriceFilteringRule[])];
  }),
);
